<template>
  <div>
    <div v-if="category">
      <div
        class="d-flex align-center justify-space-between mb-4"
        style="gap: 10px; max-width: 800px"
      >
        <div class="d-flex align-center" style="gap: 10px">
          <h1>{{ category?.name }}</h1>
          <v-btn variant="text" color="primary" @click="test">test</v-btn>
          <v-chip
            size="small"
            variant="flat"
            color="info"
            v-if="category.suggested"
            label
            ><v-icon class="mr-2">mdi-creation</v-icon> Suggested</v-chip
          >
          <v-btn
            variant="flat"
            color="button"
            @click="save"
            style="
              border-left: 1px solid #272727;
              border-right: 3px solid #272727;
              border-top: 1px solid #272727;
              border-bottom: 3px solid #272727;
              border-radius: 6px;
            "
            >Save</v-btn
          >
        </div>
        <v-btn
          prepend-icon="mdi-delete"
          variant="text"
          color="primary"
          @click="deleteCategory"
          >Delete</v-btn
        >
      </div>

      <div style="max-width: 800px">
        <v-card
          flat
          style="
            border-left: 1px solid #272727;
            border-right: 3px solid #272727;
            border-top: 1px solid #272727;
            border-bottom: 3px solid #272727;
            border-radius: 8px;
          "
          class="mb-4"
        >
          <v-sheet
            class="d-flex justify-center align-center py-2"
            color="accent"
            style="
              font-size: 10pt;
              font-weight: 600;
              border-top-right-radius: 7px;
              border-top-left-radius: 7px;
            "
          >
            Schedule
          </v-sheet>
          <v-divider class="primary"></v-divider>
          <div class="px-4 pt-4">
            <p style="font-size: 10pt; font-weight: 400">
              When should Stix AI Agent post?
            </p>
          </div>
          <div class="px-4 pb-4 d-flex align-center justify-space-between">
            <span style="font-size: 16pt; font-weight: 600">
              <ScheduleDialog :category="category" />
            </span>
            <v-switch
              color="button"
              hide-details
              label="Active"
              v-model="active"
            ></v-switch>
          </div>
        </v-card>

        <v-card
          flat
          style="
            border-left: 1px solid #272727;
            border-right: 3px solid #272727;
            border-top: 1px solid #272727;
            border-bottom: 3px solid #272727;
            border-radius: 10px;
          "
          class="mb-4"
        >
          <div>
            <v-sheet
              class="d-flex justify-center align-center py-2"
              color="accent"
              style="
                font-size: 10pt;
                font-weight: 600;
                border-top-right-radius: 7px;
                border-top-left-radius: 7px;
              "
            >
              Agent suggestions
            </v-sheet>
            <v-divider class="primary"></v-divider>
            <div class="pa-4">
              <p style="font-size: 10pt; font-weight: 400" class="mb-2">
                What would you like Stix AI Agent to suggest?
              </p>
              <v-chip-group v-model="category.agent" column multiple>
                <v-chip
                  v-for="option in ['posts', 'ideas', 'sources']"
                  :key="option"
                  :value="option"
                  filter
                  :text="option"
                  style="
                    border-left: 1px solid #272727;
                    border-right: 3px solid #272727;
                    border-top: 1px solid #272727;
                    border-bottom: 3px solid #272727;
                  "
                >
                  <template v-slot:filter>
                    <v-icon
                      size="small"
                      icon="mdi-check-circle"
                      color="primary"
                    ></v-icon>
                  </template>
                </v-chip>
              </v-chip-group>
            </div>
          </div>
        </v-card>

        <v-card
          flat
          style="
            border-left: 1px solid #272727;
            border-right: 3px solid #272727;
            border-top: 1px solid #272727;
            border-bottom: 3px solid #272727;
            border-radius: 10px;
          "
        >
          <div>
            <v-sheet
              class="d-flex justify-center align-center py-2"
              color="accent"
              style="
                font-size: 10pt;
                font-weight: 600;
                border-top-right-radius: 7px;
                border-top-left-radius: 7px;
              "
            >
              Details
            </v-sheet>
            <v-divider class="primary"></v-divider>
          </div>
          <div class="pa-4">
            <p style="font-size: 10pt; font-weight: 400" class="mb-4">
              What is this category about?
            </p>

            <v-textarea
              v-model="category.description"
              placeholder="Write a description of this category"
              rows="3"
              label="Description"
              variant="solo"
              flat
              hide-details=""
              bg-color="smokeDark"
            ></v-textarea>

            <p class="mt-4" style="font-size: 10pt">Keywords</p>
            <v-chip-group column multiple>
              <v-chip
                v-for="(keyword, index) in category.keywords"
                :key="keyword"
                color="primary"
                variant="flat"
                size="small"
                closable=""
                @click:close="category.keywords.splice(index, 1)"
              >
                {{ keyword }}
              </v-chip>
            </v-chip-group>
            <v-text-field
              v-model="newKeyword"
              placeholder="Add keyword"
              variant="solo"
              flat
              hide-details=""
              @keyup.enter="
                category.keywords.push(newKeyword);
                newKeyword = '';
                menu = false;
              "
              bg-color="smokeDark"
            >
              <template v-slot:append-inner>
                <v-btn
                  variant="text"
                  icon="mdi-plus"
                  size="x-small"
                  @click="
                    category.keywords.push(newKeyword);
                    newKeyword = '';
                    menu = false;
                  "
                ></v-btn>
              </template>
            </v-text-field>

            <p class="mt-4" style="font-size: 10pt">Goals</p>

            <div class="">
              <div v-for="(g, index) in category.goals" :key="g" class="my-2">
                <v-chip
                  multi-line
                  closable=""
                  variant="flat"
                  @click:close="category.goals.splice(index, 1)"
                  >{{ g }}</v-chip
                >
              </div>
            </div>
            <v-text-field
              placeholder="Inform audience about ..."
              variant="solo"
              flat
              hide-details=""
              bg-color="smokeDark"
              @keyup.enter="
                category.goals.push(newGoal);
                newGoal = '';
              "
              v-model="newGoal"
            >
              <template v-slot:append-inner>
                <v-btn
                  variant="text"
                  icon="mdi-plus"
                  size="x-small"
                  @click="
                    category.goals.push(newGoal);
                    newGoal = '';
                  "
                ></v-btn>
              </template>
            </v-text-field>
          </div>
        </v-card>

        <v-card
          flat
          style="
            border-left: 1px solid #272727;
            border-right: 3px solid #272727;
            border-top: 1px solid #272727;
            border-bottom: 3px solid #272727;
            border-radius: 10px;
          "
          class="mt-4 mb-10"
        >
          <div>
            <v-sheet
              class="d-flex justify-center align-center py-2"
              color="accent"
              style="
                font-size: 10pt;
                font-weight: 600;
                border-top-right-radius: 7px;
                border-top-left-radius: 7px;
              "
            >
              Sources
            </v-sheet>
            <v-divider class="primary"></v-divider>
          </div>
          <div class="px-4 pt-4 mb-4">
            <p style="font-size: 10pt; font-weight: 400">
              Add sources to help Stix AI Agent find new post ideas.
            </p>
          </div>

          <div class="px-4">
            <v-data-table
              hide-default-header
              hide-default-footer
              item-key="name"
              :items="sources"
              no-data-text="No sources found"
              :headers="[
                { text: 'URL', value: 'url' },
                { text: 'Actions', value: 'actions' },
              ]"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  variant="text"
                  icon="mdi-delete"
                  size="x-small"
                  @click="$store.dispatch('deleteSource', item)"
                ></v-btn>
              </template>
            </v-data-table>
          </div>
          <v-divider></v-divider>

          <v-text-field
            v-model="newSource"
            placeholder="Add source"
            variant="solo"
            flat
            hide-details=""
            bg-color="smokeDark"
            @keyup.enter="
              $store.dispatch('saveSource', {
                url: newSource,
                name: null,
                last_fetch: null,
                category: category.uid,
              });
              newSource = '';
            "
          >
            <template v-slot:append-inner>
              <v-btn
                variant="text"
                icon="mdi-plus"
                size="x-small"
                @click="
                  $store.dispatch('saveSource', {
                    url: newSource,
                    name: null,
                    last_fetch: null,
                    category: category.uid,
                  });
                  newSource = '';
                "
              ></v-btn>
            </template>
          </v-text-field>
        </v-card>
      </div>
    </div>
    <div v-else>
      <v-progress-circular indeterminate size="30" color="primary" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { db } from "@/firebase";
import ScheduleDialog from "@/components/scheduler/ScheduleDialog.vue";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

export default {
  name: "SocialCategory",
  components: { ScheduleDialog },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      ideas(state) {
        return state.ideas.ideas.filter(
          (i) => i.category === this.$route.params.id
        );
      },
      sources(state) {
        return state.ideas.sources?.[this.$route.params.id] || [];
      },
      schedules: (state) => state.schedules.schedules,
      accounts: (state) => state.accounts.accounts,
      posts: (state) => state.posts.posts,
    }),
    active: {
      get() {
        return (
          this.schedules.find((s) => s.uid === this.category.schedules[0])
            ?.active || false
        );
      },
      set(value) {
        const schedule = this.schedules.find(
          (s) => s.uid === this.category.schedules[0]
        );
        if (schedule) {
          schedule.active = value;
        }
        this.$store.dispatch("updateSchedule", {
          uid: this.category.schedules[0],
          active: value,
        });
      },
    },
  },
  data() {
    return {
      category: null,
      unsub: null,
      tab: 0,
      newSource: "",
      days: [
        { text: "Monday", value: 1 },
        { text: "Tuesday", value: 2 },
        { text: "Wednesday", value: 3 },
        { text: "Thursday", value: 4 },
        { text: "Friday", value: 5 },
        { text: "Saturday", value: 6 },
        { text: "Sunday", value: 7 },
      ],
      newKeyword: "",
      menu: false,
      newGoal: "",
      newUrl: "",
      newIdea: "",
    };
  },
  watch: {
    userProfile: {
      handler(newVal) {
        if (newVal && newVal.workspace) {
          this.setupListener();
        }
      },
      immediate: true,
    },

    "$route.params.id": {
      handler(newVal) {
        if (newVal) {
          this.category = null;
          this.setupListener();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async save() {
      await updateDoc(
        doc(
          db,
          "workspaces",
          this.userProfile.workspace,
          "categories",
          this.category.uid
        ),
        this.category
      );
      this.$store.commit("setNotification", {
        show: true,
        text: "Category saved!",
        type: "primary",
        icon: "mdi-check",
      });
    },
    async test() {
      console.log("Testing");
      let posts = this.posts
        .filter((p) => p.category?.uid === this.$route.params.id)
        .map((p) => p.variations[0].text);
      console.log(posts);
      const test = httpsCallable(functions, "test");
      const res = await test({
        previous_posts: posts,
        category: {
          goals: this.category.goals,
          keywords: this.category.keywords,
          description: this.category.description,
        },
      });
      console.log(res.data);
    },
    findSchedule(schedule) {
      return this.schedules.find((s) => s.uid === schedule) || null;
    },
    getDayNames(dayOfWeek) {
      if (!dayOfWeek) return "";
      const dayArray = Array.isArray(dayOfWeek) ? dayOfWeek : [dayOfWeek];
      const dayNames = dayArray
        .map((dayValue) => {
          const day = this.days.find((d) => d.value === dayValue);
          return day ? day.text : "";
        })
        .filter((name) => name);

      if (dayNames.length === 0) return "";
      if (dayNames.length === 1) return dayNames[0];
      if (dayNames.length === 2) return dayNames.join(" and ");
      return (
        dayNames.slice(0, -1).join(", ") +
        " and " +
        dayNames[dayNames.length - 1]
      );
    },
    setupListener() {
      // Clean up existing listener if any
      if (this.unsub) {
        this.unsub();
        this.unsub = null;
      }

      if (
        this.userProfile &&
        this.userProfile.workspace &&
        this.$route.params.id
      ) {
        this.unsub = onSnapshot(
          doc(
            db,
            "workspaces",
            this.userProfile.workspace,
            "categories",
            this.$route.params.id
          ),
          (doc) => {
            if (doc.exists()) {
              this.category = doc.data();
            }
          }
        );
      }
    },
  },
  beforeDestroy() {
    if (this.unsub) {
      this.unsub();
    }
  },
};
</script>

<style scoped></style>
